module.exports = __webpack_public_path__ + "img/puzzle_12.2f5cce33.png";